import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Container, IconContainer, TextContainer, ContentContainer, DropdownContainer} from './saved_filter.styled';
import ContentEditable from 'react-contenteditable';
import {VerticalDotsIcon} from '../../icons/vertical-dots-icon';
import {ContextMenu} from '../context-menu';

import {ClickAwayListener} from '@material-ui/core';

export const SavedFilter = ({
	edit,
	text,
	active,
	onChange,
	onSetChange,
	onDropdownClick,
	maxWidth,
	dropdownOptions,
	toggleActivate,
}) => {
	const inputRef = useRef();
	const [filterText, setFilterText] = useState(text);
	const [dropDownVisible, setDropdownVisible] = useState(false);

	const handleChangeText = event => {
		setFilterText(event.target.value);
		onChange(filterText);
	};

	useEffect(() => {
		if (edit) {
			inputRef.current.focus();
		}
	}, [edit]);

	useEffect(() => {
		if (filterText !== text) setFilterText(text);
	}, [text]);

	const handleKeyDown = event => {
		if (event.key === 'Enter') {
			inputRef.current.blur();
		}
		if (event.key === 'Escape') {
			setFilterText(text);
			onSetChange(filterText);
		}
	};

	const handleOnPaste = event => {
		//avoid to be able to paste images, formated text, ...
		const pasted = (event.originalEvent || event).clipboardData.getData('text/plain');
		window.document.execCommand('insertText', false, pasted);
		event.preventDefault();
	};

	const handleSetChange = () => {
		const name = inputRef.current.innerHTML
			.replace(/&nbsp;/g, ' ')
			.trim()
			.replace(/\s+/g, ' ');
		onSetChange(name);
	};

	const hideDropdown = () => {
		setDropdownVisible(false);
	};

	const showDropdown = () => {
		setDropdownVisible(true);
	};

	const contextMenuActionOnClick = callback => {
		callback();
		hideDropdown();
	};
	return (
		<Container title={filterText} edit={edit} active={active} maxWidth={maxWidth}>
			<ContentContainer onClick={toggleActivate}>
				<TextContainer active={active} edit={edit}>
					<ContentEditable
						onPaste={handleOnPaste}
						onKeyDown={handleKeyDown}
						onBlur={handleSetChange}
						innerRef={inputRef}
						html={filterText}
						onChange={handleChangeText}
						tagName="span"
						disabled={!edit}
						data-placeholder="New filter"
					/>
				</TextContainer>
				<IconContainer>
					{dropdownOptions && (
						<VerticalDotsIcon
							onClick={showDropdown}
							size={VerticalDotsIcon.SIZE.SMALL}
							color={active ? '#fff' : '#565656'}
						/>
					)}
				</IconContainer>
			</ContentContainer>
			{dropDownVisible && (
				<ClickAwayListener onClickAway={hideDropdown}>
					<DropdownContainer>
						<ContextMenu onClick={onDropdownClick} minWidth={190}>
							{dropdownOptions.map(option => (
								<ContextMenu.SingleText
									key={option.value}
									value={option.value}
									onClick={contextMenuActionOnClick.bind(this, option.callback)}
								>
									{option.text}
								</ContextMenu.SingleText>
							))}
						</ContextMenu>
					</DropdownContainer>
				</ClickAwayListener>
			)}
		</Container>
	);
};

SavedFilter.propTypes = {
	/**
	 * the text to show in the saved filter
	 */
	text: PropTypes.string.isRequired,
	/**
	 * toggle active view
	 */
	active: PropTypes.bool,
	/**
	 * Pixel maxwidth of filter label when not in edit mode
	 */
	maxWidth: PropTypes.number,
	/**
	 * Toggle edit mode
	 */
	edit: PropTypes.bool,
	/**
	 * callback when when text is changed
	 */
	onSetChange: PropTypes.func,
	onChange: PropTypes.func,
	dropdownOptions: PropTypes.arrayOf(
		PropTypes.exact({
			text: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			callback: PropTypes.func.isRequired,
		})
	),
	onDropdownClick: PropTypes.func,
	toggleActivate: PropTypes.func,
	inSlider: PropTypes.bool,
};

SavedFilter.defaultProps = {
	maxWidth: 100,
	onSetChange: () => false,
	onChange: () => false,
	onDropdownClick: () => false,
	text: '',
};
